import { HNG_APP_CONFIG, HngAppConfig } from '@hidat/ng-common';
import { environment } from '../environments/environment';
import {
  EventTrackerConfig,
  EventTrackerModule,
  loadStationInitializer,
} from '@splixer/player';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  NgxGoogleAnalyticsModule,
  NgxGoogleAnalyticsRouterModule,
} from 'ngx-google-analytics';
import { PlayerAutoPlayModes } from '@splixer/common';

const appConfig = new HngAppConfig({
  appCode: 'kexp-player',
  appName: 'KEXP Extended Archive',
  apiUrl: environment.splixerUrl,
  userApiUrl: '',
});

const eventTrackerConfig: EventTrackerConfig = {
  primaryTrackingCode: environment.defaultGaTrackingId,
};

export const kexpConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes), //, withDebugTracing()),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideAnimationsAsync(),
    { provide: HNG_APP_CONFIG, useValue: appConfig },
    importProvidersFrom(
      NgxGoogleAnalyticsModule.forRoot(environment.defaultGaTrackingId),
    ),
    importProvidersFrom(NgxGoogleAnalyticsRouterModule),
    importProvidersFrom(EventTrackerModule.forRoot(eventTrackerConfig)),
    provideAppInitializer(() => {
      return loadStationInitializer(environment.defaultStationCode, {
        featured: false,
        recents: false,
        genres: true,
        mixCategories: true,
        includeRelatedContent: false,
        dmcaSkipSeconds: 596,
        autoPlayMode: PlayerAutoPlayModes.NEXT_BROADCAST,
      });
    }),
  ],
};
